import {
  faCircleInfo,
  faCirclePlus,
  faCircleQuestion,
  faMessage,
} from '@fortawesome/free-solid-svg-icons';
import { faSquareInstagram } from '@fortawesome/free-brands-svg-icons/faSquareInstagram';
import { MenuItems } from './types';

const menuItems: MenuItems = {
  main: [
    {
      title: 'Instagram',
      icon: faSquareInstagram,
      link: 'https://www.instagram.com/quizzybooze',
    },
    {
      title: 'Frage einreichen',
      icon: faCirclePlus,
      link: '/frage-einreichen',
    },
    {
      title: 'Wie spielt man?',
      icon: faCircleQuestion,
      link: '/wie-spielt-man',
    },
    {
      title: 'Über uns',
      icon: faCircleInfo,
      link: '/ueber-uns',
    },
    {
      title: 'Feedback',
      icon: faMessage,
      link: '/feedback',
    },
  ],
  additional: [
    {
      title: 'Impressum',
      link: '/impressum',
    },
  ],
};

export default menuItems;
